import xhrService from '../xhrService';

/**
 * Signed-URL response from the report download endpoints (SW2-2076).
 */
export type SignedUrlResponse = {
  url: string;
  expiresAt: string;
  expirySeconds: number;
};

type ReportDownloadApi = {
  /** Signed S3/CDN URL for the merged report PDF. `download` forces attachment. */
  getCdnUrl: (reportId: string, download?: boolean) => Promise<SignedUrlResponse>;
  /** Signed S3/CDN URL for the pre-built ZIP package. 404s if no ZIP exists. */
  getZipUrl: (reportId: string) => Promise<SignedUrlResponse>;
};

const reportDownloadApi: ReportDownloadApi = {
  getCdnUrl: (reportId, download = true) => {
    return xhrService
      .get(`/api/reports/${reportId}/download-url`, {
        params: { download },
      })
      .then((response) => response.data);
  },

  getZipUrl: (reportId) => {
    return xhrService
      .get(`/api/reports/${reportId}/zip-url`)
      .then((response) => response.data);
  },
};

export default reportDownloadApi;
export { reportDownloadApi };
